import { TooltipDesktop } from '@cian/ui-kit';
import { HeartStroke16 } from '@cian/ui-kit/prev/icons';
import { useDeviceType } from '@cian/ui-kit/responsive';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { openNotificationsModal } from '../../../actions/notifications/openModal';
import { Utility as UtilityRedesign } from '../../../components/Utility/Redesign';
import { selectIsExperimentGroupNameB } from '../../../selectors/experiments/myHomeRedesign';
import { IApplicationState } from '../../../types/redux';
import { FavoritesTooltipContainer } from '../../FavoritesTooltip';
import { trackFavoritesIconClick } from '../tracking';

export const UtilityFavoritesContainer: React.FC = () => {
  const [isMainPage, setIsMainPage] = React.useState(false);

  const dispatch = useDispatch();
  const deviceType = useDeviceType();

  const favoritesLink = useSelector<IApplicationState, string | null>(state => state.servicesLinks.favorites);
  const favoritesCount = useSelector<IApplicationState, number>(state => state.favorites.count);

  // TODO: После завершения эксперимента выпилить ненужное
  const isExperimentGroupB = useSelector(selectIsExperimentGroupNameB);

  const handleClick = React.useCallback(() => {
    trackFavoritesIconClick();
  }, [deviceType]);

  const handleOpen = React.useCallback(() => {
    dispatch(openNotificationsModal(false));
  }, [dispatch]);

  React.useEffect(() => {
    // Открываем вкладку Избранного в той же, если переход с главной страницы
    setIsMainPage(window.location.pathname === '/');
  }, []);

  if (!favoritesLink) {
    return null;
  }

  if (isExperimentGroupB && !favoritesCount) {
    return (
      <UtilityRedesign
        title="Избранное"
        icon={HeartStroke16}
        href={favoritesLink}
        onClick={handleClick}
        target={isMainPage ? '_self' : '_blank'}
      />
    );
  }

  return (
    <TooltipDesktop
      onOpen={handleOpen}
      placement={favoritesCount ? 'bottom-end' : 'bottom'}
      theme={favoritesCount ? 'white' : 'black'}
      title={favoritesCount ? <FavoritesTooltipContainer target={isMainPage ? '_self' : '_blank'} /> : 'Избранное'}
    >
      <div data-testid="utility-title" data-name="UtilityFavoritesContainer">
        <UtilityRedesign
          title="Избранное"
          icon={HeartStroke16}
          href={favoritesLink}
          onClick={handleClick}
          target={isMainPage ? '_self' : '_blank'}
          withoutTitle={!isExperimentGroupB}
        />
      </div>
    </TooltipDesktop>
  );
};
